import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";

const secretKey = "my little secret";

export const encryptData = (data) => {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  return encryptedData;
};

export const decryptData = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(
    CryptoJS.enc.Utf8
  );
  return JSON.parse(decryptedData);
};

function shuffleWord(word) {
  // Shuffle the characters of the word
  const characters = word.split("");
  for (let i = characters.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }

  // Set the target length to 5
  const targetLength = 5;

  // Truncate or add random characters to make the length 5
  if (characters.length > targetLength) {
    characters.length = targetLength;
  } else {
    while (characters.length < targetLength) {
      const randomChar = String.fromCharCode(
        Math.floor(Math.random() * 26) + 97
      ); // Generating a random lowercase letter
      characters.push(randomChar);
    }
  }

  // Shuffle the characters again to ensure randomness
  for (let i = characters.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }

  const shuffledWord = characters.join("");
  return shuffledWord;
}

const initialState = localStorage.getItem("categoryTargetWord")
  ? JSON.parse(localStorage.getItem("categoryTargetWord"))
  : {
      categoryTargetWord: null,
      shuffleCategoryTargetWord: "",
      categoryLevel: 0,
    };

const categorySlice = createSlice({
  name: "categorySlice",
  initialState,
  reducers: {
    setCategoryTargetWord: (state, action) => {
      if (!localStorage.getItem("categoryTargetWord")) {
        console.log(action.payload, "ac");
        state.categoryTargetWord = encryptData(action.payload);
        state.shuffleCategoryTargetWord = shuffleWord(
          decryptData(state.categoryTargetWord)
        );
        localStorage.setItem("categoryTargetWord", JSON.stringify(state));
        return state;
      }
    },
    setCategoryLevel: (state, action) => {
      state.categoryLevel = state.categoryLevel + 1;
      localStorage.setItem("categoryTargetWord", JSON.stringify(state));
      return state;
    },
    resetCategoryTargetWord: (state, action) => {
      state.categoryTargetWord = "";
      state.shuffleCategoryTargetWord = "";
      state.categoryLevel = 0;
      localStorage.removeItem("categoryTargetWord");
      return state;
    },
  },
});
export const { setCategoryTargetWord, resetCategoryTargetWord } =
  categorySlice.actions;
export default categorySlice;
